import { FiltersMenuButton, FiltersMenuProvider } from '../../components';
import { PlaceOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type StateMatchingFilterProps = {
  stateShortName: string;
};

export const StateMatchingFitler: React.FC<StateMatchingFilterProps> = (props) => {
  const { classes } = useStyles();

  return (
    <FiltersMenuProvider>
      <FiltersMenuButton disabled className={classes.button}>
        <Box display="flex" gap={1} color="text.secondary" width="100%">
          <PlaceOutlined fontSize="small" />
          <Typography>
            {props.stateShortName}
          </Typography>
        </Box>
      </FiltersMenuButton>
    </FiltersMenuProvider>
  );
};

const useStyles = makeStyles()(theme => ({
  button: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 'fit-content',
      minWidth: '80px'
    },
  },
}));
